// extracted by mini-css-extract-plugin
module.exports = {"rightIcon":"rightIcon__3oozO","searchIconInOrder":"searchIconInOrder__3dNRN","storeIcon":"storeIcon__1Vgvx","searchIcon":"searchIcon__2cxcA"};